import type { FaireProductEntity } from "../../entity_types/product";

export const p_ujyrwsn6w8: FaireProductEntity = {
  token: "p_ujyrwsn6w8",
  type: "product",
  name: "Pink Zircon Butterfly Ring Steel 18K Gold S5P027",
  brandToken: "b_vzcwf2s2c8",
  brandName: "alberalkirk",
  imageUrl:
    "https://cdn.faire.com/fastly/136643734f145b439d961272b97aac8b8526c0fe15692b44f43f248dbbcf2800.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e1eed38064636433cc9be89da7da5a49a95a0b0238fd8c3f5ac121268e8268d0.jpeg",
    "https://cdn.faire.com/fastly/cfce1e58aeae0716b6743cffcdca64efed6b794a1e0e299abb895c95b6222032.jpeg",
    "https://cdn.faire.com/fastly/6bacee94562f0dd11cb64be5ab72aa2c588dd22582f93b2a1fe7cab21ee3febb.jpeg",
    "https://cdn.faire.com/fastly/a796017ed05df1f3f3e7928f214e4cbd03eda95da9c41652e85024b97bed7ac6.jpeg",
    "https://cdn.faire.com/fastly/8eb10bab22e72c09061c27fefbba29511032874d68d450f642d81f6a4b2c570a.jpeg",
  ],
  priceDollars: 11.54,
  description:
    "Material: \n * Stainless Steel \n\n Weight: \n * 21g \n\n Feature: \n * Pink Crystal Butterfly Accent \n * Romantic Vacation-Inspired Design \n * 18K Gold Plated Fade-Resistant \n * Open Adjustable Band \n * Sweet Feminine Silhouette \n\n Note: \n * Care: Avoid water & chemicals \n * Color variations: Gold/Steel tones \n * Butterfly details may vary slightly ",
  tags: [],
  msrpDollars: 23.09,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:55:25.740Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
